import { useCallback } from "react";

import type { TUseAnalyticsReturn, TAnalyticsEvent } from "./analytics.types";
import { dispatchAnalyticsEvent } from "./utils/analytics.helpers";

/** Dispara eventos de analytics (pageView, click, custom) via Adobe Launch. */
const useAnalytics = (): TUseAnalyticsReturn => {
	const trackPageView = useCallback((event: TAnalyticsEvent): void => {
		dispatchAnalyticsEvent("customPageView", event);
	}, []);

	const trackClick = useCallback((event: TAnalyticsEvent): void => {
		dispatchAnalyticsEvent(event.eventName ?? "customClick", event);
	}, []);

	const trackEvent = useCallback(
		(eventName: string, event: TAnalyticsEvent): void => {
			dispatchAnalyticsEvent(eventName, event);
		},
		[],
	);

	return { trackPageView, trackClick, trackEvent };
};

export { useAnalytics };
